<template>
    <AddBonRetour />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import AddBonRetour from "@/components/GesCom/BonRetour/AddBonRetour.vue";
  
    export default defineComponent({
      name: "AddBonRetourPage",
      components: {
        
        AddBonRetour,
      },
    });
  </script>